import script from "./DriversView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriversView.vue?vue&type=script&setup=true&lang=ts"

import "./DriversView.vue?vue&type=style&index=0&id=aab26322&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab26322"]])

export default __exports__